<div *ngIf="environments && environments.length > 1">
    <button mat-button [matMenuTriggerFor]="envPickerMenu" class="nav-env-picker-menu-button">
        <span class="nav-env-picker-menu-environment-name">{{selectedEnvironment.name}}</span>
        <span class="nav-env-picker-angle-icon fal fa-angle-down"></span>
    </button>
    <mat-menu #envPickerMenu yPosition="below" [overlapTrigger]="false">
        <button mat-menu-item *ngFor="let environment of environments" (click)="selectEnvironment(environment)">{{environment.name}}</button>
    </mat-menu>
</div>
